import { memo } from 'react';

import { PublicBoardTopBarAncestors } from '~/components/v2/components/board/PublicBoardTopBarAncestors';
import { useBoardLocationBreadcrumbs } from '~/hooks/useBoardLocationBreadcrumbs';
import { usePublicBoard } from '~/providers/PublicBoardProvider';

/**
 * The board topbar breadcrumbs for a STANDALONE public board share (`/a/{shortId}` / `/b/{boardId}`,
 * objectType 'board'). It builds only the board's own trail — ancestors + current board — because a
 * standalone share has no collection above it. The board icon leads the trail (there is no collection
 * crumb to lead it instead).
 *
 * This is the board area's own thin smart leaf over the shared dumb PublicBoardTopBarAncestors. The
 * collection area supplies its OWN builder (PublicShowcaseBoardBreadcrumbs) with the collection +
 * sub-page prefix; the two never share a "am I in a collection?" branch — that split is exactly what
 * FOUND-7 removes (one tree per route, composition over layout-swap).
 */
export const PublicBoardTopbarBreadcrumbs = memo(() => {
  const { onNavigateToBoard } = usePublicBoard();

  const items = useBoardLocationBreadcrumbs({
    // No collection crumb precedes the trail on a standalone share, so the board icon leads it.
    shouldShowBoardIcon: true,
    onBoardClick: (board) => void onNavigateToBoard({ boardId: board.id, boardTitle: board.title }),
  });

  return <PublicBoardTopBarAncestors items={items} />;
});

PublicBoardTopbarBreadcrumbs.displayName = 'PublicBoardTopbarBreadcrumbs';
